import { useState, useEffect, useRef } from 'react'

export const useDraggableChart = (chartRef: React.RefObject<HTMLDivElement>) => {
  const isDragging = useRef(false)
  const [startX, setStartX] = useState(0)
  const [scrollLeft, setScrollLeft] = useState(0)

  useEffect(() => {
    const chart = chartRef.current
    if (!chart) return

    const startDragging = (e: MouseEvent) => {
      isDragging.current = true
      setStartX(e.pageX - chart.offsetLeft)
      setScrollLeft(chart.scrollLeft)
      chart.style.cursor = 'grabbing'
    }

    const onDragging = (e: MouseEvent) => {
      if (!isDragging.current) return
      e.preventDefault()
      const x = e.pageX - chart.offsetLeft
      const walk = x - startX
      chart.scrollLeft = scrollLeft - walk
    }

    const stopDragging = () => {
      isDragging.current = false

      chart.style.cursor = 'auto'
    }

    chart.addEventListener('mousedown', startDragging)
    chart.addEventListener('mousemove', onDragging)
    chart.addEventListener('mouseleave', stopDragging)
    chart.addEventListener('mouseup', stopDragging)

    return () => {
      chart.removeEventListener('mousedown', startDragging)
      chart.removeEventListener('mousemove', onDragging)
      chart.removeEventListener('mouseleave', stopDragging)
      chart.removeEventListener('mouseup', stopDragging)
    }
  }, [startX])
}
